import { useTranslation } from 'react-i18next';
import React from 'react';
import { Box, Typography } from '@mui/material';

const NotFound = (): JSX.Element => {
  const { t } = useTranslation('component');
  return (
    <Box sx={{ textAlign: 'center', m: '24px' }}>
      <Typography variant="h1">{t('NotFound.Title')}</Typography>
    </Box>
  );
};

export default NotFound;
